export const PRINT_URL = '/print/report'
export const REPORT_CODE_PARAM = 'reportCode'
export const REPORT_CODE_PROP = 'custom'
